import React, { memo, useEffect } from 'react';
import jsPDF from 'jspdf';
import { addPageNumber } from '../common/addPageNumber';
import autoTable from 'jspdf-autotable';

interface EmergencyContactsReportProps {
    data: any;
    setPdfBlob: (blob: Blob) => void;
}

const EmergencyContactsReport: React.FC<EmergencyContactsReportProps> = ({ data, setPdfBlob }) => {
    const generatePDF = () => {
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });

        if (!data || !Array.isArray(data)) {
            return;
        }

        const sortedData = [...data].sort((a, b) => {
            const lastNameA = (a.LASTNAME || '').toUpperCase();
            const lastNameB = (b.LASTNAME || '').toUpperCase();
            if (lastNameA < lastNameB) return -1;
            if (lastNameA > lastNameB) return 1;

            const firstNameA = (a.FIRSTNAME || '').toUpperCase();
            const firstNameB = (b.FIRSTNAME || '').toUpperCase();
            if (firstNameA < firstNameB) return -1;
            if (firstNameA > firstNameB) return 1;
            return 0;
        });

        const pageWidth = doc.internal.pageSize.width;
        const margin = 10;
        let y = 15;

        // Title
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Emergency Contacts Report", pageWidth / 2, y, { align: 'center' });
        y += 10;

        // Table
        const tableData = sortedData.map((item: any, index: number) => [
            `${item.LASTNAME || ''}, ${item.FIRSTNAME || ''}`,
            item.emernamE1 || '',
            item.emercelL1 || '',
            item.emernamE2 || '',
            item.emercelL2 || '',
        ]);

        autoTable(doc, {
            head: [[
                'Staff Name',
                'Contact 1 Name',
                'Cell 1',
                'Contact 2 Name',
                'Cell 2'
            ]],
            body: tableData,
            startY: y,
            theme: 'grid',
            styles: {
                fontSize: 8,
                cellPadding: 2,
                valign: 'middle',
            },
            headStyles: {
                fillColor: [230, 230, 230], // light gray
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                halign: 'center'
            },
            columnStyles: {
                0: { cellWidth: 50 },
                1: { cellWidth: 40 },
                2: { cellWidth: 25 },
                3: { cellWidth: 40 },
                4: { cellWidth: 25 },
            },
            margin: { top: 20, bottom: 20 },
            didDrawPage: (dataArg: any) => {
                // Header on each page if needed
                if (dataArg.pageNumber > 1) {
                    doc.setFontSize(10);
                    doc.text("Emergency Contacts Report (cont.)", margin, 15);
                }
            }
        });

        addPageNumber(doc);
        const pdfBlob = doc.output('blob');
        setPdfBlob(pdfBlob);
    };

    useEffect(() => {
        if (data) {
            generatePDF();
        }
    }, [data]);

    return null;
};

export default memo(EmergencyContactsReport);